import {combineReducers} from 'redux';

/**
 * @param {ReduxRequest} reduxRequest
 * @param {ReactReduxModal} reduxModal
 * @param {ReduxRequestModalOptions} options
 * @return {{reducer: reducer, getRequestState: Function, getModalState: Function}}
 */
export function buildReducer(reduxRequest, reduxModal, options) {
  const reducer = combineReducers({
    request: reduxRequest.reducers.reducer,
    modal: reduxModal.reducers.reducer,
  });

  const getBaseState = options.getState;

  const getRequestState = rootState => getBaseState(rootState).request;
  const getModalState = rootState => getBaseState(rootState).modal;

  reduxRequest.options.getState = getRequestState;
  reduxModal.options.getState = getModalState;

  return {
    reducer,
    getRequestState,
    getModalState,
  };
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/redux-request-modal/reducers.js